import { GET_CLIENT_DETAILS_V2, GET_CLIENT_DETAILS_V2_SUCCESS, GET_CLIENT_DETAILS_V2_ERROR, GET_CLIENT_DETAILS_V2_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetClientDetailsV2 = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_DETAILS_V2:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CLIENT_DETAILS_V2_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CLIENT_DETAILS_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CLIENT_DETAILS_V2_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetClientDetailsV2;
